<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>For questions or concerns about this Privacy Policy or your personal data, please contact:</p>
    <p>
      Voxbet<br>
      Email: <a href="mailto:info@betpic.com" class="text-blue-600 dark:text-blue-400 underline">info@betpic.com</a><br>
      Website: <a href="https://betpic.com" class="text-blue-600 dark:text-blue-400 underline">betpic.com</a>
    </p>
  </div>
</template>